export default __webpack_public_path__ + "45bcde5a98dbbdf2a4e0769eca2154f1.svg";